<template>
    <div>
        <hts-modal
            :size="50"
            :show="visible"
            :title="$t('labels.selectTheLeftLane')"
            @close="close">
            <div>
                <hts-form-select
                    v-model="connectingPositions"
                    label="Vị trí liên kết"
                    multiple
                    key-id="value"
                    :readonly="!edit"
                    :items="connectingPositionItem" />

                <div
                    v-if="connectingPositions && connectingPositions.length"
                    v-loading="loading">
                    <hts-form-checkbox
                        v-if="routingConnectionItems.length"
                        v-model="routingConnections"
                        label="Trái tuyến"
                        :check-all="true"
                        class="w-full"
                        type="list"
                        :readonly="!edit"
                        :items="routingConnectionItems"
                        check-label="routingName"
                        check-key="nodeIds"
                        @change="routingConnectionChange" />
                    <p
                        v-else
                        class="mt-5">
                        Không tìm thấy trái tuyến
                    </p>
                </div>

                <div
                    v-if="edit"
                    class="flex justify-end mt-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        color="primary"
                        type="button"
                        @click="handleSaveRoutingConnections">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-modal>
    </div>
</template>

<script lang="ts" setup>
import { $lodash } from '#imports'

const props = defineProps({
  edit: {
    type: Boolean,
    default: true
  }
})
const { edit } = toRefs(props)
const emits = defineEmits(['update'])

const positions = ref()
const routingConnections = ref<string[]>([]) // keys
const routingConnectionsData = ref<string[]>([]) // values
const routingConnectionItems = ref<{ [key: string]: any }[]>([]) // list items

const connectingPositions = ref<string[]>([])
const connectingPositionItem = ref<{ [key: string]: any }[]>([])
const ready = ref<boolean>(false)

const visible = ref(false)
const loading = ref(false)

const open = async (positionsData: { [key: string]: any }[], routingConnectionsData: string[] = [], connectingPositionsData: string[] = []) => {
  connectingPositions.value = connectingPositionsData
  await getRoutingConnection(positionsData, connectingPositionsData)
  getConnectingPosition(positionsData)
  positions.value = $lodash.cloneDeep(positionsData)
  routingConnections.value = routingConnectionsData
  visible.value = true
  ready.value = true
}

const close = () => {
  routingConnections.value = []
  routingConnectionItems.value = []

  connectingPositions.value = []
  connectingPositionItem.value = []
  ready.value = false
  visible.value = false
}

const getRoutingConnection = async (positionsData: { [key: string]: any }[], connectingPositionsData: string[] = []) => {
  loading.value = true
  if (!connectingPositions.value || !connectingPositions.value?.length) {
    routingConnectionItems.value = []
    return
  }

  if (!positionsData) {
    return
  }

  const url = $urlClient.quote.quoteRequest.routingConnection
  const res = await $api(url, { body: { positions: positionsData, connectingPositions: connectingPositionsData } })
  const resData = res?.data?.value
  if (resData.success) {
    routingConnectionItems.value = resData.data || []
  }

  loading.value = false
}

watch(
  () => connectingPositions.value,
  (val) => {
    if (ready.value) {
      getRoutingConnection(positions.value, val)
    }
  }
)

watch(
  () => routingConnectionItems.value,
  (val) => {
    routingConnections.value = []
  },
  { deep: true }
)

const getConnectingPosition = (positions: { [key: string]: any }[]) => {
  connectingPositionItem.value = positions.map((item: any, index: number) => {
    return {
      value: item._id,
      label: `Vị trí ${index + 1}`
    }
  })
}

const routingConnectionChange = (val: any[]) => {
  routingConnectionsData.value = []
  routingConnectionItems.value.forEach((item: any) => {
    if (val.includes(item.nodeIds)) {
      routingConnectionsData.value.push(item.routingConnection)
    }
  })
}

defineExpose({
  open
})

const handleSaveRoutingConnections = () => {
  emits('update', {
    routingConnections: routingConnections.value || [],
    connectingPositions: connectingPositions.value || [],
    routingConnectionsData: routingConnectionsData.value || []
  })
  visible.value = false
}
</script>
